<template>

<v-container ms-auto class="pop-container">
  <v-sheet color="white" class="custom-shadow eligibleResult pa-10 overflow-hidden">
    <div :class="$style.title">
      <v-img class="mx-auto"
        max-height="250"
        max-width="250"
        src="@/assets/errorIcon.svg">
      </v-img>

      <h1 class="pb-5 pt-5">{{ omt('GenericErrorText') }}</h1>
      <BaseButton
        @click="_retryClick"
        :label="omt('RetryAction')">
      </BaseButton>
    </div>
  </v-sheet>
</v-container>
</template>

<script>
  import BaseButton from '@/shared/components/base-button.vue'

  export default {
    name : 'Error',
    page: {
      meta: [{ name: 'description', content: '500' }],
    },
    components: { 
      BaseButton
    },
    methods: {
      _retryClick() {
        document.location.href = "/";
      }
    }
  }
</script>

<style lang="scss" module>
  .title {
    text-align: center;
  }
</style>
